import AbstractComponent from './AbstractComponent';

export default class Faq extends AbstractComponent {
  private $currentQuestion: HTMLElement | undefined = undefined;
  private $questions: NodeListOf<HTMLElement>;

  public initialize(): void {
    this.$questions = document.querySelectorAll('.faq__question');

    this.$questions.forEach(($question, index) => {
      $question.querySelectorAll('a').forEach(($link) => {
        $link.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      });

      $question.addEventListener('click', (event) => this.onQuestionClicked(event));
      $question.setAttribute('data-question', `${index}`);

      const heights = this.calculateHeights($question);

      $question.style.maxHeight = heights.normal + 'px';
      $question.style.height = heights.normal + 'px';
    });
  }

  public onWindowResize() {
    this.$questions.forEach(($question) => {
      const heights = this.calculateHeights($question);

      if (this.$currentQuestion === $question) {
        $question.style.maxHeight = (heights.normal + heights.answer) + 'px';
        $question.style.height = (heights.normal + heights.answer) + 'px';
      } else {
        $question.style.maxHeight = heights.normal + 'px';
        $question.style.height = heights.normal + 'px';
      }
    });
  }

  private onQuestionClicked(event: MouseEvent): void {
    event.preventDefault();

    let $target: HTMLElement = event.target as HTMLElement;

    while (!$target.classList.contains('faq__question')) {
      $target = $target.parentElement;
    }

    this.toggleQuestion(parseInt($target.getAttribute('data-question')));
  }

  private calculateHeights($element: HTMLElement) {
    const $answer = $element.querySelector('.faq__question__answer');
    const $title = $element.querySelector('.faq__question__title');

    return {
      answer: parseInt(window.getComputedStyle($answer).height) + 10,
      normal: parseInt(window.getComputedStyle($title).height) + (1 * 2) + (14 * 2),
    };
  }

  private toggleQuestion(index: number): void {
    var $question = this.$questions[index];

    // Close the currently opened question first.
    if (this.$currentQuestion) {
      var heights = this.calculateHeights(this.$currentQuestion);

      this.$currentQuestion.classList.remove('is-open');

      this.$currentQuestion.style.maxHeight = heights.normal + 'px';
      this.$currentQuestion.style.height = heights.normal + 'px';
    }

    // If the currently opened question is the same as the newly opened
    // question, that means that the user clicked on the question and we
    // should close it instead.
    if (this.$currentQuestion !== $question) {
      var heights = this.calculateHeights($question);

      $question.classList.add('is-open');

      $question.style.maxHeight = (heights.normal + heights.answer) + 'px';
      $question.style.height = (heights.normal + heights.answer) + 'px';

      this.$currentQuestion = $question;
    } else {
      this.$currentQuestion = undefined;
    }
  }
}
